<template>
  <!--左侧input组件删除本地文件弹窗-->
  <el-dialog
    :title="$t('eventList.deleteFile')"
    :visible.sync="info.show"
    :show-close="false"
    :lock-scroll="false"
    width="550px"
  >
    <div class="content">
      <p>{{$t('eventList.deleteFileTips')}}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="cancel" @click="info.show = false">{{$t('leftPane.cancel')}}</el-button>
      <el-button type="primary" @click="deletes">{{$t('leftPane.del')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      show: true
    }
  },
  methods: {
    deletes () {
      this.info.show = false
      this.$emit('delete')
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.el-dialog {
  background: #28282e;
  .el-dialog__body{
    padding: 0px 20px !important;
  }
  .el-dialog__title {
    color: #fff;
  }
  .el-button {
    background: none;
    border: none;
    color: #999;
    font-size: 16px;
  }
  .el-button--primary {
    color: #03897b;
  }
}
.content {
  p {
    word-break: normal;
    margin-bottom: 10px;
    color: #b4b4b4;
  }
}
</style>
